import { Reveal } from "./motion";
import { IMAGES } from "../../data";

const stats = [
  { v: "7j/7", l: "Disponibilité" },
  { v: "100%", l: "Ponctualité visée" },
  { v: "3", l: "Départements couverts" },
];

export const Fleet = () => (
  <section id="flotte" data-testid="fleet" className="relative py-28 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <Reveal className="lg:col-span-8">
          <div className="spotlight rounded-2xl border border-white/10 overflow-hidden aspect-[16/10]">
            <img src={IMAGES.fleet} alt="Véhicule de la flotte" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1200ms]" />
          </div>
        </Reveal>
        <div className="lg:col-span-4 flex flex-col justify-between gap-6">
          <Reveal delay={0.1}>
            <p className="text-xs uppercase tracking-[0.3em] text-champagne font-semibold mb-4">La flotte</p>
            <h2 className="font-serif font-light text-3xl sm:text-4xl text-[#F7F5F0] leading-tight mb-4">
              Des véhicules d'exception
            </h2>
            <p className="text-[#94A3B8] leading-relaxed text-sm">
              Berlines et SUV haut de gamme, entretenus avec soin. Habitacle silencieux, sièges cuir, eau et chargeurs à disposition pour un confort absolu.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="spotlight rounded-2xl border border-white/10 overflow-hidden aspect-[4/3]">
              <img src={IMAGES.interior} alt="Intérieur cuir du véhicule" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1200ms]" />
            </div>
          </Reveal>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 mt-14 border-t border-white/10 pt-10">
        {stats.map((s, i) => (
          <Reveal key={s.l} delay={i * 0.1}>
            <p className="font-serif text-4xl sm:text-6xl text-[#F7F5F0]">{s.v}</p>
            <p className="text-[#94A3B8] text-xs sm:text-sm uppercase tracking-[0.15em] mt-2">{s.l}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
